function r(e) {
  return function(n) {
    return n?.[e];
  };
}
export {
  r as default
};
